import type { JSX } from "react";

import { Input } from "@frontend/components/atoms/Input";
import { useLingui } from "@lingui/react/macro";

import { useAddressText } from "../hooks/useAddressText";
import type { AddressFieldProps } from "../types";
import { FieldFrame } from "./FieldFrame";

/**
 * The line the street does not hold, a c/o or a building. The referential
 * says nothing about it, so it is typed as is.
 */
export function ExtendedAddressField({
  field,
  label,
  placeholder,
  size,
  disabled,
}: AddressFieldProps): JSX.Element {
  const { t } = useLingui();

  const { value, setValue, error } = useAddressText(field);

  return (
    <FieldFrame label={label} error={error}>
      <Input
        value={value}
        placeholder={placeholder ?? t`Extended address`}
        size={size}
        disabled={disabled}
        invalid={Boolean(error)}
        onValueChange={setValue}
      />
    </FieldFrame>
  );
}
